import React from "react";

import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import ArticleIcon from "@mui/icons-material/Article";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";

import { useTheme } from "@mui/material/styles";
import { useQuery } from "../hooks/useQuery";
import { useSnackbar } from "../hooks/useSnackbar";
import { handleHttpError, maskCep, maskCpf, maskPhone } from "../utils";
import { useAuth } from "../hooks/useAuth";

const MeusDados = () => {
  const theme = useTheme();
  const snackbar = useSnackbar();
  const { cnpjSemPontos, cpfComPontos, user } = useAuth();
  const { obterFornecedorPorCnpj } = useQuery();

  const [isLoading, setIsLoading] = React.useState(true);
  const [data, setData] = React.useState({
    cnpj: "",
    cpf: "",
    nome: "",
    email: "",
    data_nascimento: "",
    telefone: "",
    cep: "",
    bairro: "",
    rua: "",
    numero: "",
    complemento: "",
    cidade: "",
    estado: "",
  });

  React.useEffect(() => {
    buscarDadosFornecedor();
  }, []);

  const buscarDadosFornecedor = async () => {
    try {
      const { data: dataResponse } = await obterFornecedorPorCnpj(
        cnpjSemPontos()
      );

      const [rua, numero] = dataResponse.data.ender_fornec.split(", ");

      setData({
        cnpj: dataResponse.data.cnpj_fornec,
        cpf: cpfComPontos(),
        nome: dataResponse.data.nome_fornec,
        email: dataResponse.data.email_fornec,
        data_nascimento: "",
        telefone: maskPhone(dataResponse.data.telef_fornec),
        cep: maskCep(dataResponse.data.cep_fornec),
        bairro: dataResponse.data.bairro_fornec,
        rua: rua || "",
        numero: numero || "",
        complemento: "",
        cidade: dataResponse.data.cidade_fonec,
        estado: dataResponse.data.uf_fornec,
      });
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      mt={8}
      sx={{ width: "100%", background: "#FAFCFF", minHeight: "100vh" }}
    >
      <AppBar position="static" color="primary" style={{ padding: 10 }}>
        <Grid container spacing={0}>
          <Grid item xs={0.5}>
            <ArticleIcon
              sx={{ fontSize: 40, display: { xs: "none", md: "flex" }, mr: 1 }}
            />
          </Grid>
          <Grid item xs={11.5} alignItems="center" display="flex">
            <h3 style={{ color: "white", margin: 0 }}>Meus dados</h3>
          </Grid>
        </Grid>
      </AppBar>

      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Grid item sm={12}>
          <Card
            variant="outlined"
            style={{
              borderTop: `8px solid ${theme.palette.primary.light}`,
            }}
          >
            <CardContent>
              {isLoading ? (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <Typography component="h5" variant="h5" color="primary">
                    Meus Dados
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item sm={6}>
                      <TextField
                        value={data.cnpj}
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="CNPJ"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        value={data.nome}
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="Nome"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        value={data.cpf}
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="CPF"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        margin="normal"
                        value={data.data_nascimento}
                        disabled={true}
                        fullWidth
                        label="Data de nascimento"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        margin="normal"
                        disabled={true}
                        value={data.telefone}
                        fullWidth
                        label="Telefone"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        value={data.email}
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="E-mail"
                      />
                    </Grid>
                  </Grid>
                  <br />
                  <Typography component="h5" variant="h5" color="primary">
                    Endereço
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item sm={6}>
                      <TextField
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="Estado"
                        value={data.estado}
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="Cidade"
                        value={data.cidade}
                      />
                    </Grid>

                    <Grid item sm={6}>
                      <TextField
                        margin="normal"
                        value={data.bairro}
                        disabled={true}
                        fullWidth
                        label="Bairro"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <TextField
                        margin="normal"
                        value={data.cep}
                        disabled={true}
                        fullWidth
                        label="CEP"
                      />
                    </Grid>

                    <Grid item sm={6}>
                      <TextField
                        value={data.rua}
                        margin="normal"
                        disabled={true}
                        fullWidth
                        label="Rua"
                      />
                    </Grid>
                    <Grid item sm={6}>
                      <Grid container spacing={2}>
                        <Grid item sm={6}>
                          <TextField
                            value={data.numero}
                            margin="normal"
                            disabled={true}
                            fullWidth
                            label="Número"
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <TextField
                            value={data.complemento}
                            margin="normal"
                            disabled={true}
                            fullWidth
                            label="Complemento"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MeusDados;
